// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__1Y9w3","description":"MealItem_description__3Xl1b","price":"MealItem_price__7iM1n"};